import * as Sentry from "@sentry/nextjs";
import axios from "axios";
import Stripe from "stripe";
import * as R from "ramda";

import configClient from "@/config.client";
import { CheckoutSessionStatusResponse } from "@/types/Payments";
import ProtectedApiClient from "./ProtectedApiClient";

class PaymentsClient extends ProtectedApiClient {
  public async createCheckoutSession({
    priceLookupId,
    mode,
    returnUrl,
    customerEmail,
  }: {
    priceLookupId: string;
    mode: Stripe.Checkout.Session.Mode;
    returnUrl?: string;
    customerEmail?: string;
  }): Promise<Stripe.Checkout.Session> {
    try {
      const url = `${configClient.ALLBRIGHT_API_URL}/v1/payments/checkout/session/create`;
      const params = R.reject(R.equals(undefined))({
        priceLookupId: priceLookupId,
        mode: mode,
        returnUrl: returnUrl,
        customerEmail: customerEmail,
      });
      const response = await axios.get(url, {
        ...this.axiosConfig,
        params: params,
      });

      return response.data;
    } catch (err) {
      console.error(err);
      Sentry.captureException(err.response || err);
      throw new Error(err.response.data.message);
    }
  }

  public async getCheckoutSession(
    sessionId: string
  ): Promise<Stripe.Checkout.Session> {
    try {
      const url = `${configClient.ALLBRIGHT_API_URL}/v1/payments/checkout/session?sessionId=${sessionId}`;
      const response = await axios.get(url, this.axiosConfig);

      return response.data;
    } catch (err) {
      Sentry.captureException(err.response || err);
      throw new Error(err.response.data.message);
    }
  }

  public async getCheckoutSessionStatus(
    sessionId: string
  ): Promise<CheckoutSessionStatusResponse> {
    try {
      const url = `${configClient.ALLBRIGHT_API_URL}/v1/payments/checkout/session/status?sessionId=${sessionId}`;
      const response = await axios.get(url, this.axiosConfig);

      return response.data;
    } catch (err) {
      Sentry.captureException(err.response || err);
      throw new Error(err.response.data.message);
    }
  }
}

export default PaymentsClient;
